import "@activeadmin/activeadmin"
import TomSelect from "tom-select"
import { setupAutoInit } from "activeadmin-tom_select"

window.TomSelect = TomSelect

setupAutoInit()
